import { FC, useCallback, useEffect } from 'react';

import { Button } from 'antd';

import { trackEvent } from '../../../../../../helpers/utils/analytics';
import { useActions } from '../../../../hooks/useActions';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';

/**
 * Состав фильтра для статистики: какие условия выбраны, без самих значений —
 * в значениях бывают email и названия школ.
 */
const describeFilters = (filters: any): { blocks: number; conditions: string[] } => {
    const blocks = Array.isArray(filters) ? filters : [];
    const conditions: string[] = [];

    blocks.forEach((block: any) => {
        const items = Array.isArray(block) ? block : [ block ];
        items.forEach((item: any) => {
            const key = item?.name || item?.id || item?.key || item?.dataKey;
            if (key) conditions.push(String(key));
        });
    });

    return { blocks: blocks.length, conditions: conditions.slice(0, 50) };
};

interface IRequestButtonProps {
    btnDisabled: boolean
    setBtnDisabled: (val: boolean) => any
    setUpdateDashboard: () => void
}

const RequestButton: FC<IRequestButtonProps> = ({ btnDisabled, setBtnDisabled, setUpdateDashboard }) => {
    const { isFilterUpdate } = useTypedSelector((state) => state.meta);
    const { filterSelectorVisible, filters, currentSegment, currentFunnel } = useTypedSelector((state) => state.filter);
    const { setMetaFilterUpdate } = useActions();

    useEffect(() => {
        if (isFilterUpdate) {
            setMetaFilterUpdate({ value: false });
        }
    }, [isFilterUpdate, setBtnDisabled, setMetaFilterUpdate]);

    const sendRequest = useCallback(() => {
        trackEvent('filter-apply', {
            ...describeFilters(filters),
            segment: currentSegment?.name || null,
            funnel_steps: Array.isArray(currentFunnel) ? currentFunnel.length : 0,
        });

        setBtnDisabled(true);
        setUpdateDashboard();
    }, [setBtnDisabled, setUpdateDashboard, filters, currentSegment, currentFunnel]);

    // Глобальный обработчик Enter для применения фильтров
    useEffect(() => {
        // Не активируем если кнопка отключена или открыто модальное окно фильтра
        if (btnDisabled || filterSelectorVisible) return;

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key !== 'Enter') return;

            // Проверяем, что нет открытых модальных окон
            const hasOpenModal = document.querySelector('.ant-modal-wrap:not([style*="display: none"])');
            if (hasOpenModal) return;

            // Проверяем открытые выпадающие списки (dropdown, select, datepicker popups)
            const hasOpenDropdown = document.querySelector('.ant-picker-dropdown:not(.ant-picker-dropdown-hidden)') ||
                document.querySelector('.ant-select-dropdown:not(.ant-select-dropdown-hidden)');
            if (hasOpenDropdown) return;

            // Игнорируем Enter только в настоящих текстовых полях (не antd picker/select)
            const target = e.target as HTMLElement;
            const isRealInput = (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') &&
                !target.closest('.ant-picker') &&
                !target.closest('.ant-select') &&
                !target.closest('.ant-radio-group');

            if (isRealInput) return;

            e.preventDefault();
            sendRequest();
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [btnDisabled, filterSelectorVisible, sendRequest]);


    return (!btnDisabled) ? (
        <Button
            type="primary"
            className="request_button"
            onClick={sendRequest}
        >
            Показать
        </Button>
    ) : null;
};

export default RequestButton;
